import { iAppConfig } from "../types";

export function getConfigMessage(appConfig: iAppConfig[], key: any) {
  return appConfig?.filter((ele: iAppConfig) => ele.key === key)[0]?.value || "";
}
